<template>
  <div class="content">
    <div class="title">
      <div class="left-part">
        <b class="header">Choose Your Report Package</b>
      </div>
    </div>
    <div class="chart-div">
      <div class="page-1">
        <div class="pdf-page1-container">
          <div class="first-page">
            <div class="pdf-main">
              <!-- Left vertical section -->
              <div class="left-sidebar-container">
                <div class="date-section"></div>
                <div class="pdf-title">Due Diligence Report</div>
              </div>
              <!-- Right content section -->
              <div class="right-content">
                <div class="logo-conatiner">
                  <div class="logo">
                    <img
                      :src="getCDNlink('assets/new-assets/dark-logo.webp')"
                      class="header-logo"
                    />
                  </div>
                </div>
                <h1 class="company-name">
                  {{
                    this.$route.params.company ||
                    companyDetails?.header?.company_name ||
                    "-"
                  }}
                </h1>
                <p class="company-address">
                  {{ companyDetails?.header?.address || "-" }}
                </p>
              </div>
            </div>
            <div class="footer-cards">
              <CompanyTiles :header="header" />
            </div>
          </div>
        </div>
      </div>
      <div class="page-2">
        <div class="tile">
          <div class="header1">
            <b class="title1">Database Company Report (Instant Delivery) </b>
            <!-- <div class="stars">
              <div class="section-icons" v-html="icons?.star"></div>
              <div class="section-icons" v-html="icons?.star"></div>
              <div class="section-icons" v-html="icons?.star"></div>
              <div class="section-icons" v-html="icons?.star"></div>
              <div class="section-icons" v-html="icons?.star"></div>
            </div> -->
          </div>
          <div class="content1">
            <div class="caption-parent">
              <div class="caption1">
                <div class="caption2" style="font-weight: bolder;">
                  What's included:
                </div>
              </div>
              <div class="caption1">
                <div class="section-icons" v-html="icons?.tick"></div>
                <div class="caption2">
                  Comprehensive company profile: structure, business info &
                  background
                </div>
              </div>
              <div class="caption1">
                <div class="section-icons" v-html="icons?.tick"></div>

                <div class="caption2">
                  Financial statements with key ratios and trends
                </div>
              </div>
              <div class="caption1">
                <div class="section-icons" v-html="icons?.tick"></div>

                <div class="caption2">Shareholder & ownership details</div>
              </div>
            </div>
            <div class="number">
              USD
              {{ companyDetails?.priceMap?.NO_UPDATE?.promotion_purchase_usd }}
            </div>
          </div>
          <div class="button-parent1">
            <div class="button2" @click="toggleCheckout('NO_UPDATE')">
              <div class="wrap">
                <div class="button3">Buy Now</div>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; align-items: center; text-align: center">
          <hr style="flex: 1; border: none; border-top: 1px solid #000" />
          <span style="font-weight: bolder; margin: 0 10px"
            >Need updated data? Upgrade to the Fresh Report.</span
          >
          <hr style="flex: 1; border: none; border-top: 1px solid #000" />
        </div>
        <div class="base">
          <!-- Fresh -->
          <div class="tile1">
            <div class="header2">
              <div class="title2">
                Fresh Company Report (Delivery within 5 hours*)
              </div>
            </div>
            <div class="content1">
              <div class="caption-parent">
                <div class="caption1">
                  <div class="caption2" style="font-weight: bolder;">
                    What's additional:
                  </div>
                </div>
                <div class="caption1">
                  <div class="section-icons" v-html="icons?.tick"></div>
                  <div class="caption2">
                    Expert validation with updated Fresh Score and exposure
                    limits
                  </div>
                </div>
                <div class="caption1">
                  <div class="section-icons" v-html="icons?.tick"></div>
                  <div class="caption2">
                    Most recent financials, ownership, and related party data
                  </div>
                </div>
                <div class="caption1">
                  <div class="section-icons" v-html="icons?.tick"></div>
                  <div class="caption2">
                    Built-in AML / KYC checks for compliance-ready insights
                  </div>
                </div>
                <br/>
                *Asia working hours
              </div>
              <div class="number">
                USD
                {{ companyDetails?.priceMap?.FRESH?.promotion_purchase_usd }}
              </div>
            </div>
            <div class="button-parent1">
              <div class="button2" @click="toggleCheckout('FRESH')">
                <div class="wrap">
                  <div class="button3">Buy Now</div>
                </div>
              </div>
            </div>
          </div>
          <!-- Bundle Package -->
          <!-- <div class="tile1">
            <div class="header2">
              <div class="title2">Bundle Package</div>
              <div class="title3">Bundle Package</div>
            </div>
            <div class="content1">
              <div class="caption-parent">
                <div class="caption1">
                  <div class="section-icons" v-html="icons?.tick"></div>

                  <div class="caption2">3 company reports</div>
                </div>
                <div class="caption1">
                  <div class="section-icons" v-html="icons?.tick"></div>

                  <div class="caption2">90 days access</div>
                </div>
              </div>
              <div class="frame-div">
                <b class="caption17">Best Value</b>
                <div class="number2">USD 110.95</div>
                <div class="number3">USD 150.95</div>
              </div>
            </div>
            <div class="button-parent1">
              <div class="button2" @click="toggleCheckout('BUNDLE')">
                <div class="wrap">
                  <div class="button3">Buy Now</div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
  <EnterEmailModal
    v-if="toggleCheckoutModal"
    @close="toggleCheckout"
    :cartLoader="cartLoader"
    :companyDetails="companyDetails"
    :reportType="reportType"
  />
</template>

<script>
import CompanyTiles from "./CompanyTiles.vue";
import CompanyProfileIcons from "@/assets/DigitalReport/companyProfileIcons";
import EnterEmailModal from "@/views/Modals/EnterEmailForDigitalOrder.vue";
import config from "@/config.js";

export default {
  name: "ChooseReportPackage",
  components: {
    CompanyTiles,
    EnterEmailModal,
  },
  computed: {
    icons() {
      return CompanyProfileIcons;
    },
  },
  data() {
    return {
      companyDetails: {},
      toggleCheckoutModal: false,
      reportType: "",
    };
  },
  created() {
    this.companyDetails =
      sessionStorage.getItem("companyProfileData") &&
      JSON.parse(sessionStorage.getItem("companyProfileData"));
  },
  methods: {
    replaceSubString(date) {
      if (!date) return "";
      const newSplit = date?.split(" ")[1];
      const newSubstring = newSplit?.substr(0, 3);
      const newVal = date?.replace(newSplit, newSubstring);
      return newVal;
    },
    async toggleCheckout(type) {
      try {
        this.toggleCheckoutModal = !this.toggleCheckoutModal;
        this.reportType = type;
      } catch (error) {
        console.error("Error fetching cart items:", error);
      }
    },
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
};
</script>

<style scoped>
.remove-margin {
  margin-top: -40px;
}
.footer-cards {
  margin: 0px 20px;
}
.asOnDate {
  font-size: 12px;
}
.first-page {
  display: flex;
  flex-direction: column;
  gap: 17px;
  margin-bottom: 16px;
}

.pdf-page1-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  overflow: hidden;
  page-break-inside: avoid;
  break-inside: avoid;
  margin-top: 0px;
  margin: 0 !important;
}

.pdf-main {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: auto;
  font-family: "Figtree";
}

.left-sidebar-container {
  min-height: 60vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 27px;
  box-sizing: border-box;
  background-color: #d3f1ff;
}

.date-section {
  text-align: center;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  gap: 15px;
  font-family: "Figtree";
}

.date-title {
  font-weight: 500;
  color: #000;
  font-family: "Figtree";
}

.date-value {
  font-weight: 600;
  color: #103458;
  margin-top: 8px;
  width: 100px;
  letter-spacing: -0.02em;
  line-height: 125%;
  text-align: center;
  font-family: "Figtree";
}

.pdf-title {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  font-size: 28px;
  font-weight: 600;
  color: #103458;
  text-align: center;
  line-height: 1.2;
  overflow-wrap: break-word;
  word-break: break-word;
  font-family: "Figtree";
}

.right-content {
  flex-grow: 1;
  padding: 0px 20px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 40px;
  box-sizing: border-box;
  text-align: left;
  padding-bottom: 0px;
  margin-top: -5px;
}

.logo {
  /* width: 120px; */
  height: auto;
  object-fit: contain;
  margin: 40px 45px 0px;
  padding-top: 20px;
}

.header-logo {
  height: 40px;
}

.company-name {
  font-size: 25px;
  color: #103458;
  margin: 25px 39px;
  font-family: "Figtree";
  text-transform: uppercase;
}

.company-address {
  font-size: 18px;
  color: #1c1c1c;
  line-height: 1.6;
  margin: 40px 39px;
  width: 250px;
  font-family: "Figtree";
  margin-top: 45px;
}

.section {
  padding: 10px;
  font-size: 12px;
  color: #1c1c1c;
  line-height: 1.6;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  flex-direction: column;
  font-family: "Figtree";
}

.logo-conatiner {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
}

.section-heading {
  display: flex;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  font-family: "Figtree";
}

.section-data {
  display: flex;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  margin: 0;
  padding: 8px 0px;
  font-family: "Figtree";
}
/* ------------------------------------ */
.header {
  position: relative;
  letter-spacing: 0.25px;
  line-height: 36px;
  font-size: 20px;
  margin-bottom: 5px;
  font-family: "Figtree";
}

.left-part {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.title {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
}

.vector-icon {
  position: absolute;
  top: 76.73px;
  left: 447.59px;
  width: 159.5px;
  height: 25.2px;
}

.delivered-on {
  position: relative;
  letter-spacing: -0.02em;
  line-height: 140%;
  font-weight: 500;
}

.section-icons {
  width: 20px;
  height: 20px;
}

.p {
  margin: 0;
}

.september-2024 {
  width: 66.7px;
  position: relative;
  letter-spacing: -0.02em;
  line-height: 125%;
  font-weight: 600;
  color: #08294a;
  display: inline-block;
  height: 54px;
  flex-shrink: 0;
}

.delivered-on-parent {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 11.2px;
}

.due-diligence-report {
  font-size: 28.77px;
  letter-spacing: -0.02em;
  font-weight: 500;
  color: #103458;
  text-align: left;
  transform: rotate(-90deg);
  white-space: nowrap; /* Prevents wrapping */
  margin-top: auto; /* Pushes it to the bottom */
  margin-bottom: auto;
}

.side-panel {
  width: 118.3px; /* Fixed width */
  background-color: #edf9f9;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 35.2px 6.4px;
  box-sizing: border-box;
  text-align: center;
  flex-shrink: 0;
}

.redington-limited {
  position: absolute;
  font-size: 28.77px;
  letter-spacing: -0.02em;
  line-height: 140%;
  font-weight: 500;
  color: #103458;
  display: inline-block;
}

.credence-score {
  width: 62.3px;
  position: relative;
  letter-spacing: -0.02em;
  line-height: 130%;
  display: inline-block;
  flex-shrink: 0;
  z-index: 0;
}

.frame-child {
  position: absolute;
  top: 14.78px;
  left: 11.09px;
  border-radius: 50%;
  background: linear-gradient(270deg, #38b157, #ffff00 50%, #ff3506);
  width: 100.8px;
  height: 100.8px;
}

.minimum-risk {
  position: absolute;
  top: 52.08px;
  left: 33.71px;
  line-height: 140%;
  color: #000;
  text-align: center;
}

.a {
  position: absolute;
  top: 27.22px;
  left: 54.1px;
  font-size: 18.82px;
  line-height: 140%;
  color: #000;
  text-align: center;
}

.div {
  position: absolute;
  top: 52.08px;
  left: 0px;
  line-height: 160%;
}

.div1 {
  position: absolute;
  top: 52.08px;
  left: 113.9px;
  line-height: 160%;
}

.div2 {
  position: absolute;
  top: 17.81px;
  left: 16.8px;
  line-height: 160%;
}

.div3 {
  position: absolute;
  top: 17.81px;
  left: 96.77px;
  line-height: 160%;
}

.div4 {
  position: absolute;
  top: 0px;
  left: 57.12px;
  line-height: 160%;
}

.ellipse-parent {
  width: 128px;
  position: relative;
  height: 65.2px;
  z-index: 1;
  font-size: 8.06px;
  color: #3e4855;
}

.lucide-icons {
  width: 19px;
  position: relative;
  height: 19px;
  overflow: hidden;
  flex-shrink: 0;
}

.locked {
  width: 136px;
  margin: 0 !important;
  position: absolute;
  top: calc(50% - 36.1px);
  right: 0.23px;
  backdrop-filter: blur(60px);
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 0.3);
  height: 72px;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.scores-frame {
  position: absolute;
  top: 553.1px;
  left: 192.23px;
  border-top: 0.4px solid #939393;
  border-bottom: 0.4px solid #939393;
  box-sizing: border-box;
  width: 415px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 6.4px 0px;
  gap: 0px;
}

.block-3-plathin {
  margin: 0;
  white-space: pre-wrap;
}

.block-3-plathin-container {
  position: absolute;
  top: 359.27px;
  left: 192.23px;
  font-size: 13.19px;
  letter-spacing: -0.02em;
  line-height: 151%;
}

.lucide-icons1 {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
}

.caption {
  flex: 1;
  position: relative;
  line-height: 16px;
}

.button1 {
  position: relative;
  line-height: 24px;
  font-weight: 500;
}

.wrap {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 0px 4px;
}

.button {
  border-radius: 6px;
  background-color: #f1f5f9;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  box-sizing: border-box;
  gap: 4px;
  min-width: 80px;
  font-size: 14px;
  color: #0f172a;
}

.button-parent {
  position: absolute;
  bottom: -82px;
  left: 0px;
  border: 1px solid #e2e8f0;
  box-sizing: border-box;
  width: 661px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 16px 24px;
  gap: 8px;
  font-size: 12px;
  color: #3a4350;
  font-family: "Figtree";
}

.page-1 {
  width: 100%;
  position: relative; /* Keeps .side-panel inside */
  display: flex;
  flex-direction: row; /* Side-panel & content in a row */
  align-items: stretch; /* Ensures children match height */
  background-color: #fff;
  border: 1.5px solid #e0f5ff;
  border-radius: 8px;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  font-size: 16px;
  color: #020617;
  height: auto; /* Ensures height adjusts based on content */
  min-height: 500px; /* Prevents collapsing */
  overflow: hidden; /* Ensures no unwanted overflow */
}
.page-2 {
  width: 100%;
  position: relative; /* Keeps .side-panel inside */
  display: flex;
  flex-direction: column; /* Side-panel & content in a row */
  align-items: stretch; /* Ensures children match height */
  background-color: #eef7ff;
  border-radius: 8px;
  box-sizing: border-box;
  font-size: 16px;
  color: #020617;
  height: auto; /* Ensures height adjusts based on content */
  min-height: 500px; /* Prevents collapsing */
  overflow: hidden; /* Ensures no unwanted overflow */
  gap: 20px;
}

.title1 {
  flex: 1;
  position: relative;
  line-height: 20px;
}

.lucide-icons3 {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  object-fit: cover;
}

.stars {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 4px;
}

.header1 {
  align-self: stretch;
  background-color: #224096;
  color: #fff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 24px;
  gap: 16px;
}

.lucide-icons8 {
  width: 16px;
  position: relative;
  height: 16px;
  overflow: hidden;
  flex-shrink: 0;
  opacity: 0.5;
}

.caption2 {
  position: relative;
  line-height: 16px;
  color: #1e1e1e !important;
  font-weight: 500;
}

.caption1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 2px 0px;
  gap: 6px;
}

.caption-parent {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
}

.number {
  position: relative;
  font-size: 24px;
  letter-spacing: -0.6px;
  line-height: 100%;
  font-weight: 600;
  color: #020617;
}

.content-2 {
  flex: 1;
  width: 100%;
  position: relative;
  border-radius: 0px 0px 8px 8px;
  background-color: #fff;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 24px;
  gap: 16px;
  text-align: left;
  font-size: 16px;
  color: #020617;
  align-self: stretch;
}

.content1 {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px 24px;
  gap: 0px;
  font-size: 14px;
  color: #3a4350;
}

.button3 {
  position: relative;
  line-height: 24px;
  font-weight: 600;
}

.button2 {
  align-self: stretch;
  border-radius: 6px;
  background-color: #224096;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 8px 12px;
  box-sizing: border-box;
  min-width: 80px;
  cursor: pointer;
}

.button-parent1 {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 16px 24px;
  color: #f8fafc;
}

.tile {
  align-self: stretch;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #e2e8f0;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 240px;
}

.title2 {
  align-self: stretch;
  position: relative;
  line-height: 20px;
  font-weight: 600;
  color: #fff;
}

.title3 {
  align-self: stretch;
  position: relative;
  font-size: 12px;
  line-height: 16px;
  color: #fff;
}

.header2 {
  align-self: stretch;
  background-color: #224096;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  padding: 16px 24px;
  gap: 4px;
}

.tile1 {
  align-self: stretch;
  flex: 1;
  border-radius: 8px;
  background-color: #fff;
  border: 1px solid #e2e8f0;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  min-width: 240px;
}

.caption17 {
  position: relative;
  line-height: 16px;
  color: #3a4350;
}

.number2 {
  position: relative;
  font-size: 24px;
  letter-spacing: -0.6px;
  line-height: 100%;
  font-weight: 600;
}

.number3 {
  position: relative;
  font-size: 14px;
  text-decoration: line-through;
  line-height: 24px;
  font-weight: 500;
  opacity: 0.4;
}

.frame-div {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: 4px;
  color: #020617;
}

.base {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 24px;
  color: #020617;
}

.chart-div {
  align-self: stretch;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 24px;
  font-size: 12.79px;
  color: #000;
  font-family: "Figtree";
}

.content {
  background-color: #eef7ff;
  flex: 1;
  width: 100%;
  position: relative;
  border-radius: 0px 0px 8px 8px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 24px;
  text-align: left;
  font-size: 16px;
  color: #020617;
  letter-spacing: 0.25px;
  font-family: "Figtree";
  letter-spacing: 0.9px;
}
</style>
